<div class="emailTips-guide">
    <div class="emailTips-guide-header">
        <span>Best practices when sending emails to SMEs</span>
        <a class="close-emailTips-guide" (click)="closeExpenseDataGuide()">
            <i class="fas fa-times"></i>
        </a>
    </div>

    <div class="emailTips-guide-contet-section">
        Before sending emails to SMEs, contact client's tax department to inform their SMEs that they will be receiving surveys from KPMG.
    </div>
</div>